import React from "react";
import "./PolicyPages.scss";

function PrivacyPolicy() {
  return (
    <div className="policy-page">
      <div className="container">

        <div className="policy-card">
          <h1>Privacy Policy</h1>
          <p className="updated-text">
            Last Updated: {new Date().toLocaleDateString()}
          </p>

          <section>
            <h3>Introduction</h3>
            <p>
              UIPlus Technologies Pvt. Ltd. respects your privacy and is
              committed to protecting your personal information.
            </p>
          </section>

          <section>
            <h3>Information We Collect</h3>
            <p>
              We may collect customer information such as names, phone
              numbers, email addresses, and communication details for
              business and support purposes.
            </p>
          </section>

          <section>
            <h3>How We Use Information</h3>
            <p>
              Information is used for customer support, notifications,
              billing, WhatsApp communication, and service improvements.
            </p>
          </section>

          <section>
            <h3>Data Security</h3>
            <p>
              We implement appropriate security measures to protect user
              information from unauthorized access.
            </p>
          </section>

          <section>
            <h3>Contact Us</h3>
            <p>Email: admin@uiplus.in</p>
            <p>Website: https://uiplus.in</p>
          </section>

        </div>

      </div>
    </div>
  );
}

export default PrivacyPolicy;